var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(
    _vm.showTooltip && {
      content: _vm.passName,
      placement: 'bottom-center',
    }
  ),expression:"\n    showTooltip && {\n      content: passName,\n      placement: 'bottom-center',\n    }\n  "}],staticClass:"passes"},[_c(_vm.iconShown,{tag:"component",staticClass:"passes__icon",attrs:{"height":_vm.size,"width":_vm.size,"fill":_vm.fill}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }